import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetFeedResponse } from '../getFeed/get-feed-response';
import { getFeedResponseSchema } from '../getFeed/get-feed-response';

export async function getCollectionFeedApi(
  collectionId: number,
  cursor?: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetFeedResponse>> {
  return getRequest<IGetFeedResponse>({
    path: `/collections/${collectionId}/feed`,
    schema: getFeedResponseSchema,
    options: {
      ...options,
      params: cursor ? { cursor } : undefined,
    },
  });
}
